import * as tslib from "tslib";
import * as jdwService from "./service/service";
import * as lang from "./utils/lang";
import { execFunction } from "./helpers/execFunction";
import { Event } from "./event/Event";
import { queryStringToMap, toQueryString } from "./utils/utils";
import { LocalStorage } from "./storage/LocalStorage";
import { routeParam, urlFor } from "./utils/route";
import { EnhanceVueWidget, EnhanceWidget, fetchDataSource, RunningEnhanceVueWidget, RunningEnhanceWidget, } from "./widget/widget";
import { setGlobalIfNone, setGlobal, hasGlobal, delGlobal, getAllGlobals } from "./helpers/globals";
// declare global {
//   export interface Window {
//     // API 域名
//     API_DOMAIN?: string;
//     // 请求 401 跳转页面地址
//     LOGIN_URL?: string;
//
//     JDW_CONFIG: JdwConfig;
//
//     // SDK 导出的全局变量
//     JDW: {
//       event: typeof event;
//       store: typeof store;
//       urlFor: typeof urlFor;
//       routeParam: typeof routeParam;
//       execFunction: typeof execFunction;
//       request: typeof request;
//       requestRaw: typeof requestRaw;
//       doGet: typeof doGet;
//       doUniqueGet: typeof doUniqueGet;
//       doPost: typeof doPost;
//       toQueryString: typeof toQueryString;
//       queryStringToMap: typeof queryStringToMap;
//     };
//
//     // 本地存储
//     localStorage: Storage;
//   }
// }
var event = new Event();
var store = new LocalStorage();
export * from "./request/request";
export { EnhanceVueWidget, EnhanceWidget, event, execFunction, fetchDataSource, queryStringToMap, routeParam, RunningEnhanceVueWidget, RunningEnhanceWidget, store, toQueryString, urlFor, tslib, jdwService, lang, setGlobalIfNone, setGlobal, hasGlobal, delGlobal, getAllGlobals, };
